import React from 'react';
import { Box, Typography } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';

interface InsightsLoaderProps {
    /** Text shown under the animated icon. */
    label?: string;
}

/**
 * Branded loading indicator for the insights views: a gently pulsing AutoAwesome
 * sparkle above a label. Respects prefers-reduced-motion. Reused by the initial
 * load and the re-run overlay.
 */
const InsightsLoader: React.FC<InsightsLoaderProps> = ({ label = 'Analyzing insights…' }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
        <AutoAwesome
            sx={{
                fontSize: 40,
                color: 'primary.main',
                '@keyframes insightsPulse': {
                    '0%, 100%': { opacity: 0.5, transform: 'scale(0.9)' },
                    '50%': { opacity: 1, transform: 'scale(1.12)' },
                },
                animation: 'insightsPulse 1.4s ease-in-out infinite',
                '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
            }}
        />
        <Typography variant="body2" color="text.secondary">
            {label}
        </Typography>
    </Box>
);

export default InsightsLoader;
